import { render, staticRenderFns } from "./DayOffRestaurant.vue?vue&type=template&id=117ec28e"
import script from "./DayOffRestaurant.vue?vue&type=script&lang=js"
export * from "./DayOffRestaurant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports